export default __webpack_public_path__ + "static/media/vulnerable.72e94cfd.jpg";